import { z } from 'zod'
import { defineAction, enumerated, expression } from '~/prix'
import roadListAction from './roadList.action.json' with { type: 'json' }
import { roadObject } from '../road.data'

export const roadExpression = expression(roadObject.shape)

const roadListDefinition = defineAction({
  ...roadListAction,
  input: z.object({
    filter: roadExpression.nullish(),
    query: z.string().nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().min(0).nullish(),
    orderBy: enumerated({
      key: 'Chave',
      source: 'Origem',
      remoteId: 'Identificador remoto',
      name: 'Nome',
      municipalityId: 'Municipio',
      createdAt: 'Data de criacao',
      updatedAt: 'Data de atualizacao',
      synchronizedAt: 'Data de sincronizacao',
      deletedAt: 'Data de exclusao',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(roadObject),
    count: z.number(),
  }),
})

export default roadListDefinition
